/**
 * ERROR PAGE - SUBSCRIPTION EXCEEDED
 *
 * @version 0.1
 */

import React from 'react';

import { FormattedMessage } from 'react-intl';
import actions from './../../BatchUpload.actions';
import { hashHistory } from 'react-router';

export default class SubscriptionExceededError extends React.Component {

    goToStart() {
        actions.resetUploadToInitial();
        hashHistory.push('/start');
    }

    render() {

        return (
            <div className="subscription-exceeded-error">
                <div className="subscription-exceeded-error__notice">
                    <FormattedMessage id="Entities_Review_Error_errorCompanies.subscriptionExceeded" />
                </div>
                <button className="button-primary-lg"
                        onClick={this.goToStart}>
                    <FormattedMessage id="Entities_Review_Error_errorCompanies.returnToGetStarted" />
                </button>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/ErrorPage/ErrorPage.subscriptionExceededError.jsx